import React, { useState, useEffect } from 'react';
import { Star, ShieldCheck, User } from 'lucide-react';
import { ratingService } from '../../../services/ratingService';

function StarRating({ average, count, loading }) {
  if (loading) {
    return <div className="h-4 w-24 bg-gray-200 rounded animate-pulse mt-1" />;
  }
  if (!average) {
    return <span className="text-xs text-gray-400 mt-1">Nema ocena</span>;
  }
  return (
    <div className="flex items-center gap-1 mt-1">
      {[1, 2, 3, 4, 5]?.map(star => (
        <Star
          key={star}
          size={14}
          className={star <= Math.round(average) ? 'fill-current' : 'text-gray-300'}
          style={star <= Math.round(average) ? {color:'#CFB53B'} : {}}
        />
      ))}
      <span className="text-sm font-medium text-gray-700 ml-1">{Number(average)?.toFixed(1)}</span>
      <span className="text-xs text-gray-400">({count} {count === 1 ? 'ocena' : count >= 2 && count <= 4 ? 'ocene' : 'ocena'})</span>
    </div>
  );
}

export default function SellerInfo({ seller }) {
  const [ratingStats, setRatingStats] = useState({ average: null, count: 0 });
  const [ratingLoading, setRatingLoading] = useState(false);

  useEffect(() => {
    if (seller?.id) {
      setRatingLoading(true);
      ratingService?.getUserRatingStats(seller?.id)?.then(stats => setRatingStats(stats))?.catch(() => {})?.finally(() => setRatingLoading(false));
    }
  }, [seller?.id]);

  if (!seller) {
    return (
      <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
        <p className="text-sm text-gray-500">Informacije o prodavcu nisu dostupne</p>
      </div>
    );
  }

  const displayName = seller?.fullName || seller?.full_name || seller?.email || 'Korisnik';
  const profilePic = seller?.profilePictureUrl || seller?.profile_picture_url;

  return (
    <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">Informacije o korisniku</h3>
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className="w-12 h-12 rounded-full overflow-hidden bg-teal-100 flex items-center justify-center flex-shrink-0">
          {profilePic ? (
            <img
              src={profilePic}
              alt={displayName}
              className="w-full h-full object-cover"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          ) : (
            <User size={20} className="text-teal-600" />
          )}
        </div>
        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p className="font-semibold text-gray-900 truncate">{displayName}</p>
            <ShieldCheck size={14} className="text-teal-500 flex-shrink-0" title="Verifikovan korisnik" />
          </div>
          <StarRating average={ratingStats?.average} count={ratingStats?.count} loading={ratingLoading} />
        </div>
      </div>
    </div>
  );
}
